import React from 'react';
import { StyleSheet, View } from 'react-native';
import StarIcon from './StarIcon';
import { getStars } from './utils';
const defaultColor = '#fdd835';
const StarRatingDisplay = _ref => {
  let {
    rating,
    maxStars = 5,
    starSize = 32,
    color = defaultColor,
    emptyColor = color,
    style,
    starStyle,
    StarIconComponent = StarIcon,
    testID
  } = _ref;
  return /*#__PURE__*/React.createElement(View, {
    style: [styles.starRating, style],
    testID: testID
  }, getStars(rating, maxStars).map((starType, i) => {
    return /*#__PURE__*/React.createElement(View, {
      key: i,
      style: [styles.star, starStyle]
    }, /*#__PURE__*/React.createElement(StarIconComponent, {
      index: i,
      type: starType,
      size: starSize,
      color: starType === 'empty' ? emptyColor : color
    }));
  }));
};
const styles = StyleSheet.create({
  starRating: {
    flexDirection: 'row'
  },
  star: {
    marginHorizontal: 5
  }
});
export default StarRatingDisplay;
//# sourceMappingURL=StarRatingDisplay.js.map